<div class="d-flex flex-column gap-4">
  <cov-labeled-content
    [label]="translate('inquiries.sideDrawer.contactPanel.orderInfo.label.poNumber')"
  >
    {{ order()?.poNumber || FALLBACK_STRING }}
  </cov-labeled-content>

  <cov-labeled-content
    [label]="translate('inquiries.sideDrawer.contactPanel.orderInfo.label.productName')"
  >
    {{ order()?.productName || FALLBACK_STRING }}
  </cov-labeled-content>

  <cov-labeled-content
    [label]="translate('inquiries.sideDrawer.contactPanel.orderInfo.label.soldTo')"
  >
    <cov-address [address]="this.order()?.soldTo" />
  </cov-labeled-content>

  <cov-labeled-content
    [label]="translate('inquiries.sideDrawer.contactPanel.orderInfo.label.shipTo')"
  >
    <cov-address [address]="this.order()?.shipTo" />
  </cov-labeled-content>
</div>
